import styled from '@emotion/styled'
import { Modifiable, Mods } from '../../styles/primitives/core/mods'

export const Container = styled.div<Mods>`
	max-width: 1280px;
	padding: 20px 16px;
	margin: 0 auto;
	${Modifiable}
`
